import ImportFilterFieldNames from '@lib/enums/fieldNames/importHistoryFilterFieldNames';

export const IMPORT_FILTER_EMPTY_VALUES = {
  [ImportFilterFieldNames.Type]: [],
  [ImportFilterFieldNames.StartedAt]: '',
};
